import React from 'react';
import { EncounterType } from '../enums/encounterTypeEnum';
import './EncounterTypeRadios.css';

const EncounterTypeRadios = ({ value, onChange, disabled = false }) => (
  <div className="form-group">
    <label>Consultation type</label>
    <div
      className="details-document-type-toggle"
      role="radiogroup"
      aria-label="Consultation type"
    >
      {Object.values(EncounterType).map((type) => (
        <button
          key={type.value}
          type="button"
          role="radio"
          aria-checked={value === type.value}
          className={`details-document-type-toggle-btn ${value === type.value ? 'is-selected' : ''}`}
          onClick={() => onChange(type.value)}
          disabled={disabled}
        >
          {type.displayName}
        </button>
      ))}
    </div>
  </div>
);

export default EncounterTypeRadios;
